import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-VisaPayment',
  standalone: true,
  templateUrl: '../../assets/VisaPayment.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamVisaPaymentIcon {}
